export interface BackOrderExpediteEmailRequest {
    name: string;
    email: string;
    accountID: string;
    customerCode: string;
    contactName: string;
    phone: string;
    orderNumber: string;
    productBackOrderErpNumber: string[];
    comments: string;
}

export class BackOrderExpediteEmailRequest {
    name: string;
    email: string;
    accountID: string;
    customerCode: string;
    contactName: string;
    phone: string;
    orderNumber: string;
    productBackOrderErpNumber: string[];
    comments: string;

    constructor() {
        this.name = "";
        this.email = "";
        this.accountID = "";
        this.customerCode = "";
        this.contactName = "";
        this.phone = "";
        this.orderNumber = "";
        this.productBackOrderErpNumber = [""];
        this.comments = "";
    }
}
